import { Injectable } from "@angular/core";
import {AbstractControl, FormControl, ValidationErrors, ValidatorFn, AsyncValidatorFn} from '@angular/forms';
import { RutService } from './rut.service';
import { NumClienteService } from './numCliente.service';
import {ApiService} from './api.service';
import {map, switchMap, catchError} from 'rxjs/operators';
import {timer} from 'rxjs';
import { Observable, of } from 'rxjs';


@Injectable({
  providedIn: "root"
})

export class ValidatorService {
    static detalle(detalle: any): any {
      throw new Error('Method not implemented.');
    }
    public static nombre="[a-zñA-ZÑ áéíóúÁÉÍÓÚ]{1,200}";
    //public static rut="[0-9]{1,2}\.{0,1}[0-9]{3}\.{0,1}[0-9]{3}[-]{0,1}[0-9kK]{1}";
    public static telefono="[0-9]{9}";
    public static email="";
    public static numeroCliente="[0-9]{9}";
    public static direccion="[a-zñA-ZÑ áéíóúÁÉÍÓÚ.,\-\/0-9()]{1,200}";
    public static comuna="[a-zñA-ZÑ áéíóúÁÉÍÓÚ]{1,100}";
    public static region="[a-zñA-ZÑ áéíóúÁÉÍÓÚ]{1,100}";
    public static razonSocial="[a-zñA-ZÑ áéíóúÁÉÍÓÚ.,\-]{1,200}";
    public static giro="[a-zñA-ZÑ áéíóúÁÉÍÓÚ.,\-]{1,200}";
    public static medioPago="[a-z0-9_ñA-ZÑ áéíóúÁÉÍÓÚ]{1,30}"
    public static propuesta="[a-zñA-ZÑ áéíóúÁÉÍÓÚ.,\-\/0-9()\?\¿\¡\!%+\*:\r\n]{1,10000}";
    public static detalleSituacion="[a-zñA-ZÑ áéíóúÁÉÍÓÚ.,\-\/0-9()\?\¿\¡\!%+\*:\r\n]{1,1500}";
    public static fileTypes="png,pjp,jpg,pjpeg,jpeg,jfif,doc,docx,pdf";
    //public static fileTypes="png,pjp,jpg,pjpeg,jpeg,jfif,pdf";
    //public static mimeTypes="image/png,image/jpeg,application/pdf";
    public static mimeTypes="image/png,image/jpeg,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf";
}

export function rutValidator(control: AbstractControl) {
  var rut = new RutService().cleanSecureRut(control.value);
  if (!new RutService().ValidaRut(rut)) {
    return { rutValid: true };
  }
  return null;
}
/*
export function numClienteValidator(control: AbstractControl) {
  var numCliente = control.value;
  if (!new NumClienteService().ValidaNumCliente(numCliente)) {
    return { numClienteValid: true };
  }
  return null;
}
*/
export function numClienteValidator(numClienteService: NumClienteService): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const numCliente = control.value;
    if (!numClienteService.ValidaNumCliente(numCliente)) {
      return { numClienteValid: true };
    }
    return null;
  };
}
